import React from 'react';
import {
    ComponentSettingsManageFilters,
    ComponentSettingsExternalVisualization,
    IReportOverlaysState,
    IKpiChartOverlaysSettings,
} from '@report-content';
import { ElementType } from 'components/element-viewer';

export interface IBlocksContext {
    manageFiltersSettings: ComponentSettingsManageFilters | null;
    // Top Filters State (Used by other Components)
    setFilters: (rules: any) => void;
    filters: any;
    // Visualization extVizString (Used by Dataset)
    setExtViz: (extViz: ComponentSettingsExternalVisualization | null) => void;
    extViz: ComponentSettingsExternalVisualization | null;
    setManageFiltersReady: (ready: boolean) => void;
    manageFiltersReady: boolean;
    getFilterMask: (defaultFormat: string, filterReferenceName: string) => string;
    elementInfo?: ElementType;
    // KPI Chart overlays state, keyed by block uid - viewer-only, undefined in editor/screenshot contexts.
    reportOverlaysState?: IReportOverlaysState;
    saveBlockOverlays?: (blockUid: string, settings: IKpiChartOverlaysSettings) => void;
}
export const BlocksContext = React.createContext<IBlocksContext | null>(null);
